function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.8669 0C34.5584 0 31.8669 2.6915 31.8669 6C31.8669 9.3085 34.5584 12 37.8669 12C41.1754 12 43.8669 9.3085 43.8669 6C43.8669 2.6915 41.1754 0 37.8669 0ZM37.8669 9.09223C36.1623 9.09223 34.7747 7.70559 34.7747 6C34.7747 4.29441 36.1614 2.90777 37.8669 2.90777C39.5725 2.90777 40.9592 4.29532 40.9592 6C40.9592 7.70468 39.5725 9.09223 37.8669 9.09223Z",
  fill: "#1F459B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4333 6C15.4333 9.3085 18.1249 12 21.4333 12C24.7418 12 27.4333 9.3085 27.4333 6C27.4333 2.6915 24.7418 0 21.4333 0C18.1249 0 15.4333 2.6915 15.4333 6ZM24.5256 6C24.5256 7.70468 23.1389 9.09223 21.4333 9.09223C19.7278 9.09223 18.3411 7.70559 18.3411 6C18.3411 4.29441 19.7278 2.90777 21.4333 2.90777C23.1389 2.90777 24.5256 4.29532 24.5256 6Z",
  fill: "#1F459B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 12C9.3085 12 12 9.3085 12 6C12 2.6915 9.3085 0 6 0C2.6915 0 0 2.6915 0 6C0 9.3085 2.6915 12 6 12ZM6 2.90777C7.70468 2.90777 9.09223 4.29441 9.09223 6C9.09223 7.70559 7.70559 9.09223 6 9.09223C4.29441 9.09223 2.90777 7.70468 2.90777 6C2.90777 4.29532 4.29441 2.90777 6 2.90777Z",
  fill: "#1F459B"
});

var SvgNavOther = function SvgNavOther(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 12,
    viewBox: "0 0 44 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavOther, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-other.b655e9b4.svg";
export { ForwardRef as ReactComponent };